import { SET_NOTY_NEW_FIELD, SET_NOTY_NEW_MENU, SET_NOTY_COUNT } from 'Actions/types';

const INITIAL_STATE = {
  newField: null,
  newMenu: null,
  count: 0,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_NOTY_NEW_FIELD:
      return { ...state, newField: action.payload };
    case SET_NOTY_NEW_MENU:
      return { ...state, newMenu: action.payload };
    case SET_NOTY_COUNT:
      return { ...state, count: action.payload };
    default:
      return state;
  }
};
